import React, { useState } from 'react';
import classes from './CancelAppointmentModal.module.css';
import ModalSkeleton from '../ModalSkeleton';
import Textarea from '../../Components/UI/Textarea';
import SimpleCheckbox from '../../Components/UI/SimpleCheckbox';
import Button from '../../Components/UI/Button';
const CancelAppointmentModal = ({
  show,
  setShow,
  title = 'Cancel Appointment',
  description,
  onConfirm,
  isApiCall,
  onCancel
}) => {
  const [message, setMessage] = useState('');
  const [showMark, setShowMark] = useState(false);
  return (
    <>
      <style jsx>{`
        .modal-content {
          gap: 12px !important;
        }
      `}</style>
      <ModalSkeleton
        show={show}
        onCancel={() => setShow(false)}
        title={title}
        confirmText={'Send'}
        position="top"
        setShow={setShow}
        isApiCall={isApiCall}>
        <div className={classes.childrenWrapper}>
          <div className={classes.description}>{description}</div>
          <Textarea
            placeholder={'Add reason for cancellation'}
            label={''}
            value={message}
            setter={(e) => setMessage(e)}
            rows={3}
          />
          <div className={classes.alertWrapper}>
            <div className={classes.checkboxWrapper}>
              <SimpleCheckbox value={showMark} setter={setShowMark} />
              <p className={classes.mark}>Mark as No Show</p>
            </div>
            <div className={classes.ctaWrapper}>
              <Button
                label={'Cancel'}
                variants="secondary"
                onClick={() => {
                  if (typeof onCancel === 'function') onCancel();
                  setShow(false);
                }}
              />
              <Button
                label={'Confirm'}
                variants="primary"
                onClick={() => {
                  if (typeof onConfirm) {
                    onConfirm();
                  }
                }}
              />{' '}
            </div>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default CancelAppointmentModal;
